









































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

// models
import { FormRateLunch } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { RatesLunchService } from '@/services/config'

@Component({
    name: 'FormCreateEditRateLunch',
    components: {
        Input,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormCreateEditRateLunch extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) rateLunch!: FormRateLunch
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: FormRateLunch = {
        name: '',
        price: 0,
        is_active: true
    }

    created () {
        if (this.idEdit) {
            this.form = this.rateLunch
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                price: { required },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            this.form.price = Number(this.form.price)
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await RatesLunchService.update(this.idEdit, this.form)
                } else {
                    await RatesLunchService.save(this.form)
                }
                this.form = {
                    name: '',
                    price: 0,
                    is_active: true
                }
                alerts.success()
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
